import { createFileRoute } from '@tanstack/react-router'
import CompanyDetailsPage from '@/pages/companies/CompanyDetailsPage'

export const Route = createFileRoute('/companies/$id')({
  component: CompanyDetailsPage,
})
